/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { BatchUpdateResponse } from '../models/batch-update-response';
import { deliveryControllerBatchChangeDeliveryStatus } from '../fn/delivery/delivery-controller-batch-change-delivery-status';
import { DeliveryControllerBatchChangeDeliveryStatus$Params } from '../fn/delivery/delivery-controller-batch-change-delivery-status';
import { deliveryControllerChangeDeliveryWorkflowStatus } from '../fn/delivery/delivery-controller-change-delivery-workflow-status';
import { DeliveryControllerChangeDeliveryWorkflowStatus$Params } from '../fn/delivery/delivery-controller-change-delivery-workflow-status';
import { deliveryControllerCorrectDeliveryStatus } from '../fn/delivery/delivery-controller-correct-delivery-status';
import { DeliveryControllerCorrectDeliveryStatus$Params } from '../fn/delivery/delivery-controller-correct-delivery-status';
import { deliveryControllerCreate } from '../fn/delivery/delivery-controller-create';
import { DeliveryControllerCreate$Params } from '../fn/delivery/delivery-controller-create';
import { deliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement } from '../fn/delivery/delivery-controller-create-maintenance-delivery-from-asset-management-replacement';
import { DeliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement$Params } from '../fn/delivery/delivery-controller-create-maintenance-delivery-from-asset-management-replacement';
import { deliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts } from '../fn/delivery/delivery-controller-create-maintenance-delivery-from-products-for-spare-parts';
import { DeliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts$Params } from '../fn/delivery/delivery-controller-create-maintenance-delivery-from-products-for-spare-parts';
import { deliveryControllerCreateRepairOnCenterDelivery } from '../fn/delivery/delivery-controller-create-repair-on-center-delivery';
import { DeliveryControllerCreateRepairOnCenterDelivery$Params } from '../fn/delivery/delivery-controller-create-repair-on-center-delivery';
import { deliveryControllerDelete } from '../fn/delivery/delivery-controller-delete';
import { DeliveryControllerDelete$Params } from '../fn/delivery/delivery-controller-delete';
import { deliveryControllerDownloadOne } from '../fn/delivery/delivery-controller-download-one';
import { DeliveryControllerDownloadOne$Params } from '../fn/delivery/delivery-controller-download-one';
import { deliveryControllerFind } from '../fn/delivery/delivery-controller-find';
import { DeliveryControllerFind$Params } from '../fn/delivery/delivery-controller-find';
import { deliveryControllerFindDeliveryHistory } from '../fn/delivery/delivery-controller-find-delivery-history';
import { DeliveryControllerFindDeliveryHistory$Params } from '../fn/delivery/delivery-controller-find-delivery-history';
import { deliveryControllerFindDeliveryPreviousStatuses } from '../fn/delivery/delivery-controller-find-delivery-previous-statuses';
import { DeliveryControllerFindDeliveryPreviousStatuses$Params } from '../fn/delivery/delivery-controller-find-delivery-previous-statuses';
import { deliveryControllerFindDeliveryStatusNodes } from '../fn/delivery/delivery-controller-find-delivery-status-nodes';
import { DeliveryControllerFindDeliveryStatusNodes$Params } from '../fn/delivery/delivery-controller-find-delivery-status-nodes';
import { deliveryControllerFindOne } from '../fn/delivery/delivery-controller-find-one';
import { DeliveryControllerFindOne$Params } from '../fn/delivery/delivery-controller-find-one';
import { deliveryControllerFindProductInDelivery } from '../fn/delivery/delivery-controller-find-product-in-delivery';
import { DeliveryControllerFindProductInDelivery$Params } from '../fn/delivery/delivery-controller-find-product-in-delivery';
import { deliveryControllerPreviewBody } from '../fn/delivery/delivery-controller-preview-body';
import { DeliveryControllerPreviewBody$Params } from '../fn/delivery/delivery-controller-preview-body';
import { deliveryControllerSendEmail } from '../fn/delivery/delivery-controller-send-email';
import { DeliveryControllerSendEmail$Params } from '../fn/delivery/delivery-controller-send-email';
import { deliveryControllerSerializeProducts } from '../fn/delivery/delivery-controller-serialize-products';
import { DeliveryControllerSerializeProducts$Params } from '../fn/delivery/delivery-controller-serialize-products';
import { deliveryControllerUpdate } from '../fn/delivery/delivery-controller-update';
import { DeliveryControllerUpdate$Params } from '../fn/delivery/delivery-controller-update';
import { DeliveryHistoryResponse } from '../models/delivery-history-response';
import { DeliveryItem } from '../models/delivery-item';
import { DeliveryItemEssential } from '../models/delivery-item-essential';
import { DeliveryList } from '../models/delivery-list';
import { deliveryStatusControllerCreate } from '../fn/delivery/delivery-status-controller-create';
import { DeliveryStatusControllerCreate$Params } from '../fn/delivery/delivery-status-controller-create';
import { deliveryStatusControllerDeleteEmailConfiguration } from '../fn/delivery/delivery-status-controller-delete-email-configuration';
import { DeliveryStatusControllerDeleteEmailConfiguration$Params } from '../fn/delivery/delivery-status-controller-delete-email-configuration';
import { deliveryStatusControllerDeleteOne } from '../fn/delivery/delivery-status-controller-delete-one';
import { DeliveryStatusControllerDeleteOne$Params } from '../fn/delivery/delivery-status-controller-delete-one';
import { deliveryStatusControllerFindAll } from '../fn/delivery/delivery-status-controller-find-all';
import { DeliveryStatusControllerFindAll$Params } from '../fn/delivery/delivery-status-controller-find-all';
import { deliveryStatusControllerFindOne } from '../fn/delivery/delivery-status-controller-find-one';
import { DeliveryStatusControllerFindOne$Params } from '../fn/delivery/delivery-status-controller-find-one';
import { deliveryStatusControllerGetEmailConfiguration } from '../fn/delivery/delivery-status-controller-get-email-configuration';
import { DeliveryStatusControllerGetEmailConfiguration$Params } from '../fn/delivery/delivery-status-controller-get-email-configuration';
import { deliveryStatusControllerSetEmailConfiguration } from '../fn/delivery/delivery-status-controller-set-email-configuration';
import { DeliveryStatusControllerSetEmailConfiguration$Params } from '../fn/delivery/delivery-status-controller-set-email-configuration';
import { deliveryStatusControllerUpdate } from '../fn/delivery/delivery-status-controller-update';
import { DeliveryStatusControllerUpdate$Params } from '../fn/delivery/delivery-status-controller-update';
import { DeliveryStatusItem } from '../models/delivery-status-item';
import { DeliveryStatusList } from '../models/delivery-status-list';
import { NextStatesResponse } from '../models/next-states-response';
import { PreviousStatesResponse } from '../models/previous-states-response';
import { ProductDeliveryStockItemList } from '../models/product-delivery-stock-item-list';
import { StringItem } from '../models/string-item';

@Injectable({ providedIn: 'root' })
export class DeliveryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deliveryControllerFind()` */
  static readonly DeliveryControllerFindPath = '/delivery';

  /**
   * Restituisce le consegne.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerFind()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFind$Response(params: DeliveryControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryList;
}>> {
    return deliveryControllerFind(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le consegne.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerFind$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFind(params: DeliveryControllerFind$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryList;
}> {
    return this.deliveryControllerFind$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryList;
}>): BaseResponse & {
'data'?: DeliveryList;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerCreate()` */
  static readonly DeliveryControllerCreatePath = '/delivery';

  /**
   * Crea una consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCreate$Response(params: DeliveryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
    return deliveryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCreate(params: DeliveryControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItem;
}> {
    return this.deliveryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>): BaseResponse & {
'data'?: DeliveryItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerFindProductInDelivery()` */
  static readonly DeliveryControllerFindProductInDeliveryPath = '/delivery/products-in-delivery';

  /**
   * Dato un ordine, restituisce le quantità già in consegna per prodotto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerFindProductInDelivery()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindProductInDelivery$Response(params: DeliveryControllerFindProductInDelivery$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductDeliveryStockItemList;
}>> {
    return deliveryControllerFindProductInDelivery(this.http, this.rootUrl, params, context);
  }

  /**
   * Dato un ordine, restituisce le quantità già in consegna per prodotto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerFindProductInDelivery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindProductInDelivery(params: DeliveryControllerFindProductInDelivery$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductDeliveryStockItemList;
}> {
    return this.deliveryControllerFindProductInDelivery$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductDeliveryStockItemList;
}>): BaseResponse & {
'data'?: ProductDeliveryStockItemList;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerFindDeliveryHistory()` */
  static readonly DeliveryControllerFindDeliveryHistoryPath = '/delivery/delivery-histories/{id}';

  /**
   * Elenco dello storico di una consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerFindDeliveryHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindDeliveryHistory$Response(params: DeliveryControllerFindDeliveryHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryHistoryResponse;
}>> {
    return deliveryControllerFindDeliveryHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Elenco dello storico di una consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerFindDeliveryHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindDeliveryHistory(params: DeliveryControllerFindDeliveryHistory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryHistoryResponse;
}> {
    return this.deliveryControllerFindDeliveryHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryHistoryResponse;
}>): BaseResponse & {
'data'?: DeliveryHistoryResponse;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerBatchChangeDeliveryStatus()` */
  static readonly DeliveryControllerBatchChangeDeliveryStatusPath = '/delivery/batch/change-status';

  /**
   * Cambio stato massivo consegne.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerBatchChangeDeliveryStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerBatchChangeDeliveryStatus$Response(params: DeliveryControllerBatchChangeDeliveryStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BatchUpdateResponse;
}>> {
    return deliveryControllerBatchChangeDeliveryStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Cambio stato massivo consegne.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerBatchChangeDeliveryStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerBatchChangeDeliveryStatus(params: DeliveryControllerBatchChangeDeliveryStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BatchUpdateResponse;
}> {
    return this.deliveryControllerBatchChangeDeliveryStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BatchUpdateResponse;
}>): BaseResponse & {
'data'?: BatchUpdateResponse;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerChangeDeliveryWorkflowStatus()` */
  static readonly DeliveryControllerChangeDeliveryWorkflowStatusPath = '/delivery/change-delivery-status/{id}';

  /**
   * Modifica lo stato di una consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerChangeDeliveryWorkflowStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerChangeDeliveryWorkflowStatus$Response(params: DeliveryControllerChangeDeliveryWorkflowStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
    return deliveryControllerChangeDeliveryWorkflowStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica lo stato di una consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerChangeDeliveryWorkflowStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerChangeDeliveryWorkflowStatus(params: DeliveryControllerChangeDeliveryWorkflowStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItem;
}> {
    return this.deliveryControllerChangeDeliveryWorkflowStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>): BaseResponse & {
'data'?: DeliveryItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerCorrectDeliveryStatus()` */
  static readonly DeliveryControllerCorrectDeliveryStatusPath = '/delivery/correct-delivery-status/{id}';

  /**
   * Corregge lo stato di una consegna riportandola a uno stato precedente del workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerCorrectDeliveryStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCorrectDeliveryStatus$Response(params: DeliveryControllerCorrectDeliveryStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
    return deliveryControllerCorrectDeliveryStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Corregge lo stato di una consegna riportandola a uno stato precedente del workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerCorrectDeliveryStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCorrectDeliveryStatus(params: DeliveryControllerCorrectDeliveryStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItem;
}> {
    return this.deliveryControllerCorrectDeliveryStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>): BaseResponse & {
'data'?: DeliveryItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerFindDeliveryStatusNodes()` */
  static readonly DeliveryControllerFindDeliveryStatusNodesPath = '/delivery/nodes/{id}';

  /**
   * Restituisce gli stati successivi della consegna disponibili in base a quello attuale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerFindDeliveryStatusNodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindDeliveryStatusNodes$Response(params: DeliveryControllerFindDeliveryStatusNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>> {
    return deliveryControllerFindDeliveryStatusNodes(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli stati successivi della consegna disponibili in base a quello attuale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerFindDeliveryStatusNodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindDeliveryStatusNodes(params: DeliveryControllerFindDeliveryStatusNodes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: NextStatesResponse;
}> {
    return this.deliveryControllerFindDeliveryStatusNodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>): BaseResponse & {
'data'?: NextStatesResponse;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerFindDeliveryPreviousStatuses()` */
  static readonly DeliveryControllerFindDeliveryPreviousStatusesPath = '/delivery/previous-nodes/{id}';

  /**
   * Restituisce gli stati precedenti della consegna nel workflow, per correggere un errore di assegnazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerFindDeliveryPreviousStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindDeliveryPreviousStatuses$Response(params: DeliveryControllerFindDeliveryPreviousStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PreviousStatesResponse;
}>> {
    return deliveryControllerFindDeliveryPreviousStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli stati precedenti della consegna nel workflow, per correggere un errore di assegnazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerFindDeliveryPreviousStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindDeliveryPreviousStatuses(params: DeliveryControllerFindDeliveryPreviousStatuses$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PreviousStatesResponse;
}> {
    return this.deliveryControllerFindDeliveryPreviousStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PreviousStatesResponse;
}>): BaseResponse & {
'data'?: PreviousStatesResponse;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement()` */
  static readonly DeliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacementPath = '/delivery/maintenance-delivery-from-asset-management-replacement';

  /**
   * Crea una consegna di manutenzione generata dalla sostituzione di un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement$Response(params: DeliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
    return deliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una consegna di manutenzione generata dalla sostituzione di un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement(params: DeliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItem;
}> {
    return this.deliveryControllerCreateMaintenanceDeliveryFromAssetManagementReplacement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>): BaseResponse & {
'data'?: DeliveryItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerCreateRepairOnCenterDelivery()` */
  static readonly DeliveryControllerCreateRepairOnCenterDeliveryPath = '/delivery/repair-on-center';

  /**
   * Crea la consegna di riparazione on center: spedisce al fornitore il seriale del ticket (che deve essere in un magazzino).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerCreateRepairOnCenterDelivery()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCreateRepairOnCenterDelivery$Response(params: DeliveryControllerCreateRepairOnCenterDelivery$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deliveryControllerCreateRepairOnCenterDelivery(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea la consegna di riparazione on center: spedisce al fornitore il seriale del ticket (che deve essere in un magazzino).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerCreateRepairOnCenterDelivery$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCreateRepairOnCenterDelivery(params: DeliveryControllerCreateRepairOnCenterDelivery$Params, context?: HttpContext): Observable<void> {
    return this.deliveryControllerCreateRepairOnCenterDelivery$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts()` */
  static readonly DeliveryControllerCreateMaintenanceDeliveryFromProductsForSparePartsPath = '/delivery/maintenance-delivery-from-products-for-spare-parts';

  /**
   * Crea una consegna di manutenzione generata da ricambio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts$Response(params: DeliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
    return deliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una consegna di manutenzione generata da ricambio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts(params: DeliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItem;
}> {
    return this.deliveryControllerCreateMaintenanceDeliveryFromProductsForSpareParts$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>): BaseResponse & {
'data'?: DeliveryItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerFindOne()` */
  static readonly DeliveryControllerFindOnePath = '/delivery/{id}';

  /**
   * Restituisce una consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindOne$Response(params: DeliveryControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
    return deliveryControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerFindOne(params: DeliveryControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItem;
}> {
    return this.deliveryControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>): BaseResponse & {
'data'?: DeliveryItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerDelete()` */
  static readonly DeliveryControllerDeletePath = '/delivery/{id}';

  /**
   * Elimina una consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerDelete$Response(params: DeliveryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItemEssential;
}>> {
    return deliveryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerDelete(params: DeliveryControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItemEssential;
}> {
    return this.deliveryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItemEssential;
}>): BaseResponse & {
'data'?: DeliveryItemEssential;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerUpdate()` */
  static readonly DeliveryControllerUpdatePath = '/delivery/{id}';

  /**
   * Modifica una consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerUpdate$Response(params: DeliveryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
    return deliveryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica una consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerUpdate(params: DeliveryControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItem;
}> {
    return this.deliveryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>): BaseResponse & {
'data'?: DeliveryItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerDownloadOne()` */
  static readonly DeliveryControllerDownloadOnePath = '/delivery/{id}/download';

  /**
   * Restituisce una consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerDownloadOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerDownloadOne$Response(params: DeliveryControllerDownloadOne$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return deliveryControllerDownloadOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerDownloadOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerDownloadOne(params: DeliveryControllerDownloadOne$Params, context?: HttpContext): Observable<Blob> {
    return this.deliveryControllerDownloadOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `deliveryControllerSerializeProducts()` */
  static readonly DeliveryControllerSerializeProductsPath = '/delivery/{id}/serialize-products';

  /**
   * Serializza i prodotti indicati di una consegna esistente (aggiunge/collega/scollega seriali) senza toccare gli altri prodotti o campi della consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerSerializeProducts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerSerializeProducts$Response(params: DeliveryControllerSerializeProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
    return deliveryControllerSerializeProducts(this.http, this.rootUrl, params, context);
  }

  /**
   * Serializza i prodotti indicati di una consegna esistente (aggiunge/collega/scollega seriali) senza toccare gli altri prodotti o campi della consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerSerializeProducts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerSerializeProducts(params: DeliveryControllerSerializeProducts$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryItem;
}> {
    return this.deliveryControllerSerializeProducts$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>): BaseResponse & {
'data'?: DeliveryItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerPreviewBody()` */
  static readonly DeliveryControllerPreviewBodyPath = '/delivery/{id}/preview-body';

  /**
   * Anteprima body email per la consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerPreviewBody()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerPreviewBody$Response(params: DeliveryControllerPreviewBody$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>> {
    return deliveryControllerPreviewBody(this.http, this.rootUrl, params, context);
  }

  /**
   * Anteprima body email per la consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerPreviewBody$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryControllerPreviewBody(params: DeliveryControllerPreviewBody$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StringItem;
}> {
    return this.deliveryControllerPreviewBody$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>): BaseResponse & {
'data'?: StringItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryControllerSendEmail()` */
  static readonly DeliveryControllerSendEmailPath = '/delivery/{id}/send-email';

  /**
   * Invia email per la consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryControllerSendEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerSendEmail$Response(params: DeliveryControllerSendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return deliveryControllerSendEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia email per la consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryControllerSendEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryControllerSendEmail(params: DeliveryControllerSendEmail$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.deliveryControllerSendEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `deliveryStatusControllerFindAll()` */
  static readonly DeliveryStatusControllerFindAllPath = '/delivery-status';

  /**
   * Recupera tutti gli stati consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryStatusControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerFindAll$Response(params: DeliveryStatusControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusList;
}>> {
    return deliveryStatusControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera tutti gli stati consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryStatusControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerFindAll(params: DeliveryStatusControllerFindAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryStatusList;
}> {
    return this.deliveryStatusControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusList;
}>): BaseResponse & {
'data'?: DeliveryStatusList;
} => r.body)
    );
  }

  /** Path part for operation `deliveryStatusControllerCreate()` */
  static readonly DeliveryStatusControllerCreatePath = '/delivery-status';

  /**
   * Crea uno stato consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryStatusControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryStatusControllerCreate$Response(params: DeliveryStatusControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>> {
    return deliveryStatusControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea uno stato consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryStatusControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryStatusControllerCreate(params: DeliveryStatusControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryStatusItem;
}> {
    return this.deliveryStatusControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>): BaseResponse & {
'data'?: DeliveryStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryStatusControllerFindOne()` */
  static readonly DeliveryStatusControllerFindOnePath = '/delivery-status/{id}';

  /**
   * Restituisce uno stato consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryStatusControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerFindOne$Response(params: DeliveryStatusControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>> {
    return deliveryStatusControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce uno stato consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryStatusControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerFindOne(params: DeliveryStatusControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryStatusItem;
}> {
    return this.deliveryStatusControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>): BaseResponse & {
'data'?: DeliveryStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryStatusControllerDeleteOne()` */
  static readonly DeliveryStatusControllerDeleteOnePath = '/delivery-status/{id}';

  /**
   * Elimina uno stato consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryStatusControllerDeleteOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerDeleteOne$Response(params: DeliveryStatusControllerDeleteOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>> {
    return deliveryStatusControllerDeleteOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina uno stato consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryStatusControllerDeleteOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerDeleteOne(params: DeliveryStatusControllerDeleteOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryStatusItem;
}> {
    return this.deliveryStatusControllerDeleteOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>): BaseResponse & {
'data'?: DeliveryStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryStatusControllerUpdate()` */
  static readonly DeliveryStatusControllerUpdatePath = '/delivery-status/{id}';

  /**
   * Modifica uno stato consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryStatusControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryStatusControllerUpdate$Response(params: DeliveryStatusControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>> {
    return deliveryStatusControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica uno stato consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryStatusControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryStatusControllerUpdate(params: DeliveryStatusControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeliveryStatusItem;
}> {
    return this.deliveryStatusControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>): BaseResponse & {
'data'?: DeliveryStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `deliveryStatusControllerGetEmailConfiguration()` */
  static readonly DeliveryStatusControllerGetEmailConfigurationPath = '/delivery-status/{id}/email-configuration';

  /**
   * Recupera la configurazione email di uno stato consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryStatusControllerGetEmailConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerGetEmailConfiguration$Response(params: DeliveryStatusControllerGetEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deliveryStatusControllerGetEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera la configurazione email di uno stato consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryStatusControllerGetEmailConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerGetEmailConfiguration(params: DeliveryStatusControllerGetEmailConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.deliveryStatusControllerGetEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deliveryStatusControllerSetEmailConfiguration()` */
  static readonly DeliveryStatusControllerSetEmailConfigurationPath = '/delivery-status/{id}/email-configuration';

  /**
   * Imposta la configurazione email per uno stato consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryStatusControllerSetEmailConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryStatusControllerSetEmailConfiguration$Response(params: DeliveryStatusControllerSetEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deliveryStatusControllerSetEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Imposta la configurazione email per uno stato consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryStatusControllerSetEmailConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deliveryStatusControllerSetEmailConfiguration(params: DeliveryStatusControllerSetEmailConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.deliveryStatusControllerSetEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deliveryStatusControllerDeleteEmailConfiguration()` */
  static readonly DeliveryStatusControllerDeleteEmailConfigurationPath = '/delivery-status/{id}/email-configuration';

  /**
   * Rimuove la configurazione email di uno stato consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryStatusControllerDeleteEmailConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerDeleteEmailConfiguration$Response(params: DeliveryStatusControllerDeleteEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deliveryStatusControllerDeleteEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Rimuove la configurazione email di uno stato consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryStatusControllerDeleteEmailConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryStatusControllerDeleteEmailConfiguration(params: DeliveryStatusControllerDeleteEmailConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.deliveryStatusControllerDeleteEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
